import { useState } from "react";
import { ghostBtnClass, inputClass } from "@/components/manufacturing/manufacturingSurfaceClasses";

export function useQcListControls<T>(rows: T[], match: (row: T, query: string) => boolean, pageSize = 10) {
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(0);
  const needle = query.trim().toLowerCase();
  const filtered = needle ? rows.filter((row) => match(row, needle)) : rows;
  const pages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const safePage = Math.min(page, pages - 1);
  return {
    query,
    setQuery: (value: string) => {
      setQuery(value);
      setPage(0);
    },
    page: safePage,
    setPage,
    pages,
    rows: filtered.slice(safePage * pageSize, safePage * pageSize + pageSize),
    total: filtered.length,
  };
}

export function QcListPager({
  page,
  pages,
  onPage,
}: {
  page: number;
  pages: number;
  onPage: (page: number) => void;
}) {
  return (
    <div className="flex items-center gap-2 text-sm text-gray-900 dark:text-zinc-100">
      <button type="button" className={ghostBtnClass} disabled={page <= 0} onClick={() => onPage(page - 1)}>
        Previous
      </button>
      <span>Page {page + 1} of {pages}</span>
      <button type="button" className={ghostBtnClass} disabled={page + 1 >= pages} onClick={() => onPage(page + 1)}>
        Next
      </button>
    </div>
  );
}

export function QcListFilter({
  value,
  onChange,
  placeholder,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}) {
  return (
    <input className={inputClass} value={value} placeholder={placeholder} onChange={(event) => onChange(event.target.value)} />
  );
}
